import MockJS from 'mockjs'

export default [
  {
    name: 'helpQuery',
    path: '',
    method: 'get',
    params: {},
    mock: MockJS.mock({
      code: 200,
      'data|8': [{
        'title|1': ['@csentence', '@ctitle'],
        hot: '@boolean'
      }]
    }),
    desc: '帮助文档列表'
  },
  {
    name: 'defenceList',
    path: '',
    method: 'get',
    params: {},
    mock: MockJS.mock({
      code: 200,
      'data|3': [{
        'title|1': ['@csentence', '@ctitle'],
        value: '@integer(10, 100)',
        'unit|1': ['Mbps', 'QPS']
      }]
    }),
    desc: '防护数据汇总'
  },
  {
    name: 'bandwidthData',
    path: '',
    method: 'get',
    params: {},
    mock: MockJS.mock({
      code: 200,
      data: {
        peakValue: '@integer(10, 100)',
        totalFlow: '@integer(10, 100)',
        feeValue: '@integer(10, 100)',
        peakTime: '@datetime',
        xAxis: { 'data|9': ['@datetime'] },
        series: [
          { name: '国际专线（Mbps）', 'data|9': ['@integer(20, 50)'], smooth: true, color: '#2D74FF' },
          { name: '业务带宽（Mbps）', 'data|9': ['@integer(20, 50)'], smooth: true, color: '#45DE7F' },
          { name: '总带宽（Mbps）', 'data|9': ['@integer(20, 50)'], smooth: true, color: '#FFC318' }
        ]
      }
    }),
    desc: '带宽总览'
  },
  {
    name: 'domainList',
    path: '/console2/homePage/domainList',
    method: 'post',
    params: {},
    mock: false,
    desc: '首页域名列表'
  }
]
